/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Proud_Mole_Filter_AllInputs */

const fr_witty_proud_mole_filter_all = /** @type {(inputs: Witty_Proud_Mole_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous`)
};

/**

* @param {Witty_Proud_Mole_Filter_AllInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_proud_mole_filter_all = /** @type {((inputs?: Witty_Proud_Mole_Filter_AllInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Proud_Mole_Filter_AllInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_proud_mole_filter_all(inputs)
});